/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Hero_BodyInputs */

const da_forside_hero_body = /** @type {(inputs: Forside_Hero_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AImforA giver et forslag til point, karakter og feedback i matematik og dansk, ud fra jeres egen rettevejledning. Du ser besvarelsen ved siden af, retter det, du er uenig i, og godkender.`)
};

/** @type {(inputs: Forside_Hero_BodyInputs) => LocalizedString} */
const en_forside_hero_body = da_forside_hero_body;

/**

* @param {Forside_Hero_BodyInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_hero_body = /** @type {((inputs?: Forside_Hero_BodyInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Hero_BodyInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_hero_body(inputs)
	return /** @type {LocalizedString} */ ("AImforA giver et forslag til point, karakter og feedback i matematik og dansk, ud fra jeres egen rettevejledning. Du ser besvarelsen ved siden af, retter det, du er uenig i, og godkender.")
});